import React, { useMemo, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { T2, getTranslatedText, useIntl } from '@nile/components'
import { SrcInfoContainer } from '@nile/banyan/src/Utils/style'
import styled from 'styled-components'
import { Button, ButtonGroup, TextStyle } from '@superops/ui-design-system'
import { planDescriptionKeyMap } from '@nile/banyan/src/Utils/pricingHelper'
import { SVGIcon } from '@superops/super-icons'
import FeatureLineItem from '@nile/components/src/Pages/Pricing/PricingPageContainer/FeatureLineItem'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { ContentWrapper } from '@nile/components/src/Pages/Pricing/PricingPageContainer/styles'

const InfoContainer = styled(SrcInfoContainer)`
  margin: 25px 0px;
  .btn-switcher {
    align-items: baseline;
  }
`

const PlanDetailCardWrapper = styled.div`
  .pricing-plans-content-wrap {
    min-height: 206px;
  }
  .feature-parent {
    margin-top: 48px;
    margin-bottom: 24px;
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 30px;
    color: #170426;
  }
  .feature {
    margin-bottom: 8px;
    font-family: Poppins, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #4d4d4d;
    position: relative;
  }
  .back-btn {
    cursor: pointer;
  }
  .payment-holder {
    justify-content: flex-end;
    display: flex;
  }
`

const PlanDetailCard = (props) => {
  const {
    selectedPlan,
    setSelectedPlan,
    isNew,
    allFeatures,
    availablePlans,
    planFeatures,
    selectPlan,
    isUpgradeCard,
    subscriptionTypes
  } = props

  const intl = useIntl()
  const flags = useFlags()
  const availableFeatures = planFeatures?.[selectedPlan.chargeBeePlanId]

  const [selectedPlanIdx, setSelectedPlanIdx] = useState(0)

  const newPlanFeaturesList = useMemo(() => {
    let planType
    const matchingSubscription = subscriptionTypes
      ? Object.values(subscriptionTypes).find(
          (el) => el?.chargeBeePlanId === selectedPlan?.chargeBeePlanId
        )
      : null
    if (matchingSubscription) {
      planType = matchingSubscription.planType

      const processedFeaturesList = Object.entries(allFeatures).map(
        ([featureTitle, features]) => {
          const title = featureTitle.split('_').join(' ')
          const featuresList = features?.filter((feat) => feat[planType])

          return featuresList?.length
            ? { labelKey: title, features: featuresList }
            : null
        }
      )

      return processedFeaturesList
    } else {
      return []
    }
  }, [allFeatures, selectedPlan, subscriptionTypes])

  const getFeatureList = (el) => {
    return (
      <>
        {el?.features?.length > 0 && (
          <FeatureLineItem
            features={el?.features}
            labelKey={el?.labelKey}
            detailCard
            plan={selectedPlan}
          />
        )}
        {el?.subcategories &&
          el?.subcategories?.map((subel) => getFeatureList(subel))}
      </>
    )
  }

  return (
    <PlanDetailCardWrapper className='full-width fh'>
      <InfoContainer className=' display-block fh w100'>
        <div className='plr-15 fh'>
          {setSelectedPlan && (
            <div
              className='back-btn mb10'
              onClick={() => setSelectedPlan(null)}
            >
              <SVGIcon name='BackArrow' />
            </div>
          )}
          <div className='flex'>
            <div className='f11'>
              <p className='name'>{selectedPlan?.planName}</p>
              <p className='excerpt'>
                <TextStyle variation='subdued'>
                  {selectedPlan?.chargeBeePlanId
                    ? getTranslatedText(
                        intl,
                        planDescriptionKeyMap[selectedPlan?.chargeBeePlanId]
                      )
                    : ''}
                </TextStyle>
              </p>
              <div className='line' />
            </div>
            {isUpgradeCard && (
              <div className='flex jend btn-switcher ml-26'>
                <ButtonGroup segmented>
                  <Button
                    disabled={!selectedPlanIdx}
                    onClick={() => {
                      const idx = selectedPlanIdx - 1
                      setSelectedPlanIdx(idx)
                      selectPlan(idx)
                    }}
                    outline
                    icon={<SVGIcon name='ArrowLeft' />}
                  />
                  <Button
                    disabled={selectedPlanIdx === availablePlans.length - 1}
                    outline
                    onClick={() => {
                      const idx = selectedPlanIdx + 1
                      setSelectedPlanIdx(idx)
                      selectPlan(idx)
                    }}
                    icon={<SVGIcon name='ArrowRight' />}
                  />
                </ButtonGroup>
              </div>
            )}
          </div>
          <ContentWrapper className='featureCard scroll' scaleHeight>
            {isNew
              ? newPlanFeaturesList?.map((el) => getFeatureList(el))
              : newPlanFeaturesList.map((feature) => {
                  return (
                    <div className='pricing-plans-content-wrap'>
                      <p className='feature-parent'>{feature}</p>
                      {selectedPlan?.planFeatures
                        ?.filter((subfeat) => subfeat.module === feature)
                        ?.map((subfeat) => (
                          <p className='feature'>
                            <T2>{subfeat.featureName}</T2>
                          </p>
                        ))}
                    </div>
                  )
                })}
          </ContentWrapper>
        </div>
      </InfoContainer>
    </PlanDetailCardWrapper>
  )
}

export default withRouter(PlanDetailCard)
